import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SubtractEnclosedSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM11.9957 20.5272C7.27809 20.5272 3.48562 16.7283 3.48562 12C3.48562 7.27167 7.26938 3.47276 11.9869 3.47276C16.7132 3.47276 20.5192 7.27167 20.5192 12C20.5192 16.7283 16.7219 20.5272 11.9957 20.5272ZM7.97667 12.7442H16.0146C16.4891 12.7442 16.829 12.4786 16.829 12.0253C16.829 11.5554 16.5104 11.281 16.0146 11.281H7.97667C7.47218 11.281 7.15355 11.5554 7.15355 12.0253C7.15355 12.4786 7.4935 12.7442 7.97667 12.7442Z"
        fill={color}
      />
    </svg>
  );
};

export { SubtractEnclosedSvg };
